// extracted by mini-css-extract-plugin
export default {"kybTab":"KYB_kybTab__8eDvo","kybContent":"KYB_kybContent__6xoQR"};